// extracted by mini-css-extract-plugin
export default {"avatar":"Nc1I4Vs1VBIIu6dUKGrd","letters":"taEnkFkIaAhcFnZtlZqU"};